var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLandingGraph = function SvgLandingGraph(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 329.501,
    height: 100,
    viewBox: "0 0 329.501 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #eee;\n        stroke: #ccc;\n      }\n\n      .cls-2, .cls-5, .cls-7 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n      }\n\n      .cls-3 {\n        fill: #ddd;\n        stroke: #666;\n        opacity: 0.5;\n      }\n\n      .cls-4 {\n        fill: #4d4d4f;\n        font-size: 8px;\n        font-family: Roboto-Regular, Roboto;\n      }\n\n      .cls-5 {\n        stroke: #25556e;\n        stroke-dasharray: 2 1;\n      }\n\n      .cls-6 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "landing_-_graph",
    "data-name": "landing - graph",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    className: "cls-1",
    transform: "translate(33)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 295,
    height: 100,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0.5,
    y: 0.5,
    width: 294,
    height: 99,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    className: "cls-2",
    x2: 292,
    transform: "translate(34.5 32.5)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    className: "cls-2",
    x2: 292,
    transform: "translate(34.5 65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_5",
    "data-name": "Intersection 5",
    className: "cls-3",
    d: "M-2981,91.5a4.5,4.5,0,0,1-4.5-4.5V34.092h26.027l8.853,2.573c2.213.643,11.064-2.573,11.064-2.573l25.531,2.573h34.5l28.981,2.6,24.6,4.578,32.975-4.578,13.765,16.782h32.484l9.883,13.6,21.187,4.909,18.154,1.984h6.5V87a4.5,4.5,0,0,1-4.5,4.5Z",
    transform: "translate(3019 8)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_220_kW",
    "data-name": "220 kW",
    className: "cls-4",
    transform: "translate(13 9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.305,
    y: 0
  }, "220 kW")), /*#__PURE__*/React.createElement("text", {
    id: "_160_kW",
    "data-name": "160 kW",
    className: "cls-4",
    transform: "translate(13 41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.305,
    y: 0
  }, "160 kW")), /*#__PURE__*/React.createElement("text", {
    id: "_100_kW",
    "data-name": "100 kW",
    className: "cls-4",
    transform: "translate(13 73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.305,
    y: 0
  }, "100 kW")), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    className: "cls-5",
    x2: 292,
    transform: "translate(34.5 46.5)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLandingGraph);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/landing-graph.3c85cfb7475fc5885eb8e77cb9472990.svg";